import { hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { resolveGeoRoute, geoRouteHead } from "@/lib/geoRouteSeo";
import NotFound from "@/pages/NotFound";
import LocationDepth2Route from "@/pages/LocationDepth2Route";
import { stateSlugs } from "@/data/towns";
import { getApprovedTownContent } from "@/lib/townContent.functions";
import { getLocationTarget } from "@/data/locationTargets";

export const Route = createFileRoute("/_public/locations/$a/$b")({
  loader: async ({ params }) => {
    if (!resolveGeoRoute([params.a, params.b])) throw notFound();
    // /locations/:state/:town  → town copy
    // /locations/:region/:service → region-service copy
    const isTown = stateSlugs.has(params.a);
    const target = isTown
      ? getLocationTarget(params.a, params.b)
      : getLocationTarget("", params.a);
    if (!target) return { content: null };
    try {
      const content = await getApprovedTownContent({
        data: {
          stateSlug: target.stateSlug,
          townSlug: target.slug,
          serviceSlug: isTown ? null : params.b,
        },
      });
      return { content };
    } catch {
      return { content: null };
    }
  },
  component: LocationDepth2Page,
  head: ({ params, loaderData, matches }) => geoRouteHead([params.a, params.b], Boolean(loaderData) && !hasUnavailableMatch(matches)),
  notFoundComponent: NotFound,
  errorComponent: NotFound,
});

function LocationDepth2Page() {
  const { content } = Route.useLoaderData();
  return <LocationDepth2Route content={content} />;
}
